import { styled } from 'styled-components';

import { cssBreakpoints } from '#/theme/theme';

export const LayoutHeaderBackToResultsArrowHolder = styled.div`
  display: flex;
  align-items: center;

  @media (min-width: ${cssBreakpoints.mdUp}) {
    display: none;
  }
`;
